module.exports = __webpack_public_path__ + "static/23-what-is-proptech-0eb6da5e022df496f99f1e9235dd0ffa.jpg";